import { RadioButtonUnchecked } from '@mui/icons-material';
import CheckCircleTwoTone from '@mui/icons-material/CheckCircleTwoTone';
import EditIcon from '@mui/icons-material/EditTwoTone';
import { Contact } from '@api/Trinium/Endpoints/Contact/types';
import MailLink from '@components/MailLink';

import styles from './MobileCard.module.css';

interface ContactMobileCardProps {
	row: Contact;
	onEdit: (row: Contact) => void;
}

export default function ContactMobileCard({ row, onEdit }: ContactMobileCardProps) {
	return (
		<div className={styles.card}>
			<div className={styles.header}>
				<div className={styles.cell}>{row.name}</div>
				<EditIcon
					titleAccess='Edit Row'
					color='primary'
					onClick={() => {
						onEdit(row);
					}}
				/>
			</div>
			<div className={styles.content}>
				<div className={styles['card-content']}>
					<div className={styles.cell}>
						<div className={styles['flex-row']}>
							<div>
								{row.phone && (
									<div>
										<span className={styles['heading']}>Phone</span>
										<span className={styles['value']}>{row.phone}</span>
									</div>
								)}
								{row.fax && (
									<div>
										<span className={styles['heading']}>Fax</span>
										<span className={styles['value']}>{row.fax}</span>
									</div>
								)}
							</div>
							<div className={styles['icon']}>
								<span className={styles['heading']}>Main?</span>
								{row.isMain ? (
									<CheckCircleTwoTone
										color='success'
										className={styles['checkbox']}
										fontSize='small'
									/>
								) : (
									<RadioButtonUnchecked
										className={styles['checkbox']}
										fontSize='small'
									/>
								)}
							</div>
						</div>
						<div className={styles['flex-row']}>
							{row.email && (
								<div>
									<span className={styles['heading']}>Email</span>
									<MailLink
										emailAddress={row.email}
										showIcon={false}
									/>
								</div>
							)}
						</div>
						{row.notes && (
							<div className={styles['flex-row']}>
								<div>
									<span className={styles['heading']}>Notes</span>
									<span className={styles['value']}>{row.notes}</span>
								</div>
							</div>
						)}
					</div>
				</div>
			</div>
		</div>
	);
}
